import { ApiResponse, PaginatedApiResponse } from 'types/ApiResponse';

// Core data types matching Mongoose model
export interface Translation {
  _id?: string;
  id?: string;
  companyId?: string | null;
  languageCode: string | null;
  languageName?: string | null;
  // AR Mode Popup fields
  arPopupTitle?: string | null;
  arStep1Title?: string | null;
  arStep1Description?: string | null;
  arStep2Title?: string | null;
  arStep2Description?: string | null;
  // 3D Viewer Popup fields
  threeDPopupTitle?: string | null;
  threeDStep1Title?: string | null;
  threeDStep1Description?: string | null;
  threeDStep2Title?: string | null;
  threeDStep2Description?: string | null;
  threeDButtonText?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface Language {
  code: string;
  name: string;
  state: 'active' | 'inactive';
}

// API request types
export interface CreateTranslationData {
  companyId?: string | null;
  languageCode: string | null;
  languageName?: string | null;
  // AR Mode Popup fields
  arPopupTitle?: string | null;
  arStep1Title?: string | null;
  arStep1Description?: string | null;
  arStep2Title?: string | null;
  arStep2Description?: string | null;
  // 3D Viewer Popup fields
  threeDPopupTitle?: string | null;
  threeDStep1Title?: string | null;
  threeDStep1Description?: string | null;
  threeDStep2Title?: string | null;
  threeDStep2Description?: string | null;
  threeDButtonText?: string | null;
}

export interface UpdateTranslationData extends Partial<CreateTranslationData> {
  id: string;
}

export interface TranslationFilters {
  page?: number;
  limit?: number;
  search?: string;
  languageCode?: string;
  companyId?: string;
}

// State types
export interface LocalizationState {
  // Languages management
  languages: Language[];
  selectedLanguage: string;
  
  // Text management
  currentTranslation: Translation | null;
  
  // Auto-save state
  autoSave: {
    status: 'idle' | 'saving' | 'saved' | 'error';
    lastSaved: string | null;
    pendingChanges: boolean;
  };
  
  // UI states
  modals: {
    addLanguage: boolean;
    editLanguage: {
      isOpen: boolean;
      language: Language | null;
    };
    editTranslation: {
      isOpen: boolean;
      languageCode: string | null;
    };
  };
  
  loading: {
    languages: boolean;
    translations: boolean;
    saving: boolean;
  };
  
  error: string | null;
}

// API response types
export type TranslationResponse = ApiResponse<Translation>;
export type TranslationsListResponse = PaginatedApiResponse<Translation>;
export type LanguagesResponse = ApiResponse<Language[]>;

export const initialState: LocalizationState = {
  languages: [],
  selectedLanguage: 'en',
  currentTranslation: null,
  autoSave: {
    status: 'idle',
    lastSaved: null,
    pendingChanges: false,
  },
  modals: {
    addLanguage: false,
    editLanguage: {
      isOpen: false,
      language: null,
    },
    editTranslation: {
      isOpen: false,
      languageCode: null,
    },
  },
  loading: {
    languages: false,
    translations: false,
    saving: false,
  },
  error: null,
};
